<template>
  <p class="page-description">
    <span
        ref="content"
        :class="{'hide-text' : !toggle}"
    >
      <slot></slot>
    </span>
    <button
        v-show="showBtn"
        class="white btn btn-link"
        @click="toggle = !toggle"
    >
      <span v-show="!toggle" class="dots">...</span>
      <span class="show-text">
        {{ toggle ? t('show_less') : t('show_more') }}
      </span>
    </button>
  </p>
</template>

<script lang="ts" setup>
const {t} = useI18n()
const toggle = ref(false)
const showBtn = ref(false)
const content = ref<HTMLElement | null>(null)

const hasEllipsis = computed(() => {
  const el = content.value
  if (!el) return false
  return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight
})


onMounted(() => {
  showBtn.value = hasEllipsis.value
})
</script>

<style lang="scss" scoped>
.page-description {
  position: relative;
  color: var(--surfaces-on-surface-variable);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 175% */

  .hide-text {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .btn-link {
    padding: 0 0 0 4px;
    position: absolute;
    bottom: 2px;
    right: 0;
    display: inline-flex;
    gap: 8px;
    font-size: inherit;
    color: inherit;
    line-height: inherit;
    background: var(--accent-on-primary);

    .dots {
      font-size: inherit;
      color: inherit;
      line-height: inherit;
      position: relative;
      top: 2px;
    }

    .show-text {
      color: var(--surfaces-on-surface);
      font-size: inherit;
      font-style: normal;
      font-weight: 600;
      line-height: inherit;
      text-decoration-line: underline;
    }

  }
}


</style>
